import Vue from 'vue'
import App from './App.vue'
import 'vant/lib/index.less'

import 'amfe-flexible'

import VueRouter from 'vue-router'
import router from './router'
import store from './store'

import {
  Pagination,
  // Dialog,
  // Autocomplete,
  // Dropdown,
  // DropdownMenu,
  // DropdownItem,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Input,
  // InputNumber,
  Radio,
  RadioGroup,
  // RadioButton,
  Checkbox,
  // CheckboxButton,
  CheckboxGroup,
  // Switch,
  // Select,
  // Option,
  // OptionGroup,
  Button,
  ButtonGroup,
  // Table,
  // TableColumn,
  DatePicker,
  // TimeSelect,
  // TimePicker,
  Popover,
  // Tooltip,
  // Breadcrumb,
  // BreadcrumbItem,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Tag,
  // Tree,
  // Alert,
  // Slider,
  Icon,
  Row,
  Col,
  Upload,
  // Progress,
  Spinner,
  // Badge,
  // Card,
  // Rate,
  // Steps,
  // Step,
  Carousel,
  CarouselItem,
  Collapse,
  CollapseItem,
  // Cascader,
  // CascaderPanel,
  // ColorPicker,
  // Transfer,
  // Container,
  // Header,
  // Aside,
  // Main,
  // Footer,
  // Timeline,
  // TimelineItem,
  // Link,
  // Divider,
  Image,
  // Calendar,
  // Backtop,
  // PageHeader,
  Loading,
  MessageBox,
  Message
  // Notification
} from 'element-ui'
Vue.use(Pagination) // 分页
// Vue.use(Dialog) // 对话框
// Vue.use(Autocomplete) // 可带输入建议的输入框组件
// Vue.use(Dropdown) // 下拉菜单
// Vue.use(DropdownMenu) // 下拉菜单
// Vue.use(DropdownItem) // 下拉菜单
Vue.use(Menu) // 导航菜单
Vue.use(Submenu) // 导航菜单
Vue.use(MenuItem) // 导航菜单
Vue.use(MenuItemGroup) // 导航菜单
Vue.use(Input) // 输入框
// Vue.use(InputNumber) // 计数器
Vue.use(Radio) // 单选框
Vue.use(RadioGroup) // 单选框组
// Vue.use(RadioButton) // 按钮样式的单选组合
Vue.use(Checkbox) // 多选框
// Vue.use(CheckboxButton) // 按钮样式的多选组合
Vue.use(CheckboxGroup) // 多选框组
// Vue.use(Switch) // 开关
// Vue.use(Select) // 选择器
// Vue.use(Option) // 选择器属性值
// Vue.use(OptionGroup) // 选择器分组
Vue.use(Button) // 按钮
Vue.use(ButtonGroup) // 按钮组
// Vue.use(Table) // 表格
// Vue.use(TableColumn) // 表格的列
Vue.use(DatePicker) // 日期选择器
// Vue.use(TimeSelect) // 时间选择器
// Vue.use(TimePicker) // 时间选择器
Vue.use(Popover) // 弹出框
// Vue.use(Tooltip) // 文字提示
// Vue.use(Breadcrumb) // 面包屑
// Vue.use(BreadcrumbItem) // 面包屑
Vue.use(Form) // 表单
Vue.use(FormItem) // 表单域
Vue.use(Tabs) // 标签页
Vue.use(TabPane) // 标签页选项卡
Vue.use(Tag) // 标签
// Vue.use(Tree) // 树形控件
// Vue.use(Alert) // 警告
// Vue.use(Slider) // 滑块
Vue.use(Icon) // 图标
Vue.use(Row) // 图标
Vue.use(Col) // 图标
Vue.use(Upload) // 上传
// Vue.use(Progress) // 进度条
// Vue.use(Badge) // 标记
// Vue.use(Card) // 卡片
// Vue.use(Rate) // 评分
// Vue.use(Steps) // 步骤条
// Vue.use(Step) // 步骤
Vue.use(Carousel) // 走马灯，循环播放同一类型的图片、文字等内容
Vue.use(CarouselItem) // 走马灯某一张
Vue.use(Collapse) // 折叠面板
Vue.use(CollapseItem) // 某一个折叠面板
// Vue.use(Cascader) // 级联选择器
// Vue.use(CascaderPanel) // 级联选择器
// Vue.use(ColorPicker) // 颜色选择器
// Vue.use(Transfer) // 穿梭框
// Vue.use(Container) // 布局容器
// Vue.use(Header) // 顶栏容器
// Vue.use(Aside) // 侧边栏容器
// Vue.use(Main) // 主要区域容器
// Vue.use(Footer) // 底栏容器
// Vue.use(Timeline) // 时间线
// Vue.use(TimelineItem) // 时间流信息
// Vue.use(Link) // 文字链接
// Vue.use(Divider) // 分割线
Vue.use(Image) // 图片
// Vue.use(Calendar) // 日历
// Vue.use(Backtop) // 回到顶部
// Vue.use(PageHeader) // 页头
Vue.use(Spinner) // 加载数据时显示动效
Vue.use(Loading.directive) // 加载
Vue.prototype.$loading = Loading.service // 加载
Vue.prototype.$msgbox = MessageBox // 消息提示
Vue.prototype.$alert = MessageBox.alert // 消息提示
Vue.prototype.$confirm = MessageBox.confirm // 消息提示
Vue.prototype.$prompt = MessageBox.prompt // 消息提示
// Vue.prototype.$notify = Notification // 通知
Vue.prototype.$message = Message // 消息提示

Vue.use(VueRouter)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
